import { theme } from '../../theme';

function formatTime(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
}

export default function ConversationCard({ conv, isActive, onSelect, onViewHistory }) {
  const preview = conv.last_message || '';
  return (
    <div
      onClick={() => onSelect(conv)}
      style={{
        padding: '12px 16px', cursor: 'pointer',
        background: isActive ? theme.colors.glowStrong : 'transparent',
        borderBottom: `1px solid ${theme.colors.border}`,
        display: 'flex', flexDirection: 'column', gap: '4px',
        borderLeft: isActive ? `3px solid ${theme.colors.primary}` : '3px solid transparent',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: theme.colors.text, fontWeight: 600, fontSize: '0.9rem' }}>
          📱 {conv.owner}
        </span>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ color: theme.colors.textMuted, fontSize: '0.72rem' }}>{formatTime(conv.updated_at)}</span>
          <button
            onClick={(e) => { e.stopPropagation(); onViewHistory(conv); }}
            style={{
              background: 'transparent', border: `1px solid ${theme.colors.border}`,
              borderRadius: '4px', padding: '2px 7px', cursor: 'pointer',
              color: theme.colors.primary, fontSize: '0.72rem',
            }}
          >
            Ver
          </button>
        </div>
      </div>
      <span style={{ color: theme.colors.textMuted, fontSize: '0.8rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px' }}>
        {preview || '…'}
      </span>
    </div>
  );
}
